// removed by extract-text-webpack-plugin
module.exports = {"body":"AppBody__body___2GdDL","body-no-scroll":"AppBody__body-no-scroll___RVdzW AppBody__body___2GdDL"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/AppBody/AppBody.scss
// module id = 523
// module chunks = 0